import React, { useCallback, useMemo } from 'react'
import { TimePicker } from 'antd'
import dayjs, { type Dayjs } from 'dayjs'
import { ConfigProvider } from 'antd'
import locale from 'antd/es/locale/ru_RU'
import { ITime } from './interface'

function range(start: number, end: number): number[] {
  return Array
    .from({ length: end - start })
    .map((_, index) => start + index)
}

function InputTime({ value, onChange, UISchema }: ITime) {
  const disabled = useMemo(() => Boolean(UISchema?.options?.disabled), [UISchema])
  const isDisabledTimePrev = useMemo(() => {
    return UISchema?.options?.isDisabledTimePrev === true
  }, [UISchema])

  const style = UISchema?.style
  const disabledTime = useCallback((_date?: Dayjs) => {
    if(isDisabledTimePrev){
      return {
        disabledHours: () => {
          const now = dayjs()
          const currentHours = now.hour()
          return range(0, currentHours)
        },
        disabledMinutes: (selectedHours: number) => {
          const now = dayjs()
          const currentHours = now.hour()
          const currentMinutes = now.minute()
          if(currentHours === selectedHours){
            return range(0, currentMinutes)
          }
          if(selectedHours === -1){
            return range(0, 60)
          }
          return range(60, 60)
        } 
      }
    }
    return {
      disabledHours: () => [],
      disabledMinutes: () => []
    }
  } ,[isDisabledTimePrev]) 

  const handleChange = useCallback(nextValue => {
    if (nextValue) {
      onChange(nextValue.toISOString())
    } else {
      onChange(null)
    }
  }, [onChange])

  return (
    <ConfigProvider locale={locale}>
      <TimePicker
        disabledTime={disabledTime}
        format='HH:mm'
        onChange={handleChange}
        value={value ? dayjs(value) : null}
        disabled={disabled}
        style={style}
      />
    </ConfigProvider>
  )
}

export default InputTime